<template>
  <div class="Authentication">

    <Head :lanshow="ActiveName" :title="$tc('header.back')" />
    <!-- <NavBar /> -->
    <h5 class="mianbaoxie">
      <span>当前位置：</span><span>首页></span><span>个人中心</span>
    </h5>
    <div class="Authentication-center">
      <!-- 认证表单 -->
      <div v-if="form.status == 1">
        <div class="Authentication-title">
          <p v-if="isVolunteerCertification == 1">义务监督员认证</p>
          <p v-if="isVolunteerCertification == 2">志愿者认证</p>
          <i></i>
        </div>
        <div class="Authentication-content">
          <van-form @submit="onSubmit" style="font-size: 3vw">
            <van-cell-group class="form_filed">
              <div class="label">
                <span class="xinhao">*</span><span class="jianju">学历</span>
              </div>
              <van-field readonly clickable class="input_box" name="picker" :value="formList.education" placeholder="请选择" @click="showPicker = true" :rules="[
                  {
                    required: true,
                    message: '必填',
                  },
                ]" />
              <van-popup v-model="showPicker" position="bottom">
                <van-picker show-toolbar :columns="columns" @confirm="onConfirms" @cancel="showPicker = false" />
              </van-popup>
            </van-cell-group>
            <div>
              <div>
                <!-- 籍贯 -->
                <van-cell-group class="form_filed">
                  <div class="label"><span>籍贯</span></div>
                  <div class="van-cell van-field noBorder">
                    <!-- :value="formList.native_place.province1 ? areaList.province_list.find((v) => v.id / 1 === formList.native_place.province1).name  : ''" -->
                    <van-field style="margin-right: 2vw" readonly clickable :value="province_val" name="picker" placeholder="请选择" @click="pikerShow.native_place__province1 = true">
                      <template #button>
                        <span style="color: rgba(102, 102, 102, 1)">省</span>
                      </template>
                    </van-field>
                    <!-- :value="
                        formList.native_place.city1
                          ? areaList.city_list.find(
                              (v) => v.id / 1 === formList.native_place.city1
                            ).name
                          : ''
                      " -->
                    <!-- :value="formList.native_place.city1 ? areaList.city_list.find((v) => v.id / 1 === formList.native_place.city1).name : ''" -->
                    <van-field style="margin-right: 2vw" readonly clickable name="picker" :value="city1_val" placeholder="请选择" @click="
                        formList.native_place.province1 &&
                          (pikerShow.native_place__city1 = true)
                      ">
                      <template #button>
                        <span style="color: rgba(102, 102, 102, 1)">市</span>
                      </template>
                    </van-field>
                    <van-popup v-model="pikerShow.native_place__province1" position="bottom">
                      <van-picker value-key="name" show-toolbar :columns="areaList.province_list.slice(1)" @confirm="
                          (value) =>
                            onConfirmCity(
                              value,
                              'native_place__province1',
                              'native_place__city1',
                              '3'
                            )
                        " @cancel="pikerShow.native_place__province1 = false" />
                    </van-popup>
                    <van-popup v-model="pikerShow.native_place__city1" position="bottom">
                      <van-picker value-key="name" show-toolbar :columns="areaList.city_list" @confirm="
                          (value) =>
                            onConfirmCity(value, 'native_place__city1', '', '4')
                        " @cancel="pikerShow.native_place__city1 = false" />
                    </van-popup>
                  </div>
                </van-cell-group>
                <!-- 民族 -->
                <van-cell-group class="form_filed">
                  <div class="label">
                    <span class="xinhao">*</span><span class="jianju">民族</span>
                  </div>

                  <van-field readonly clickable name="picker" class="input_box" :value="formList.nation" placeholder="请选择" @click="showPicker2 = true" :rules="[
                      {
                        required: true,
                        message: '必填',
                      },
                    ]" />
                  <van-popup v-model="showPicker2" position="bottom">
                    <van-picker show-toolbar :columns="nationList" @confirm="onConfirms1" @cancel="showPicker2 = false" />
                  </van-popup>
                </van-cell-group>
                <!-- 身份证号 -->
                <van-cell-group class="form_filed" v-if="isVolunteerCertification != 2">
                  <div class="label">
                    <span class="xinhao">*</span><span class="jianju">身份证号</span>
                  </div>
                  <van-field v-model="formList.idCard" placeholder="请输入身份证号" class="input_box" maxlength="18" type="text" :rules="[
                    {
                      required: true,
                      message: '必填',
                    },
                    {
                      pattern: /[0-9a-zA-Z]$/,
                      message: '支持18个字',
                    },
                  ]" />
                </van-cell-group>
                <!-- 政治面貌 -->
                <van-cell-group class="form_filed">
                  <div class="label">
                    <span class="xinhao">*</span><span class="jianju">政治面貌</span>
                  </div>

                  <van-field readonly clickable class="input_box" name="picker" :value="formList.politicsStatus" placeholder="请选择" @click="showPicker3 = true" :rules="[
                      {
                        required: true,
                        message: '必填',
                      },
                    ]" />
                  <van-popup v-model="showPicker3" position="bottom">
                    <van-picker show-toolbar :columns="columns1" @confirm="onConfirms2" @cancel="showPicker3 = false" />
                  </van-popup>
                </van-cell-group>
                <!-- 出生日期 -->
                <van-cell-group class="form_filed">
                  <div class="label">
                    <span class="xinhao">*</span><span class="jianju">出生日期</span>
                  </div>

                  <van-field readonly clickable class="input_box" name="datetimePicker" :value="formList.birthDate" placeholder="请选择" @click="showPicker1 = true" :rules="[
                      {
                        required: true,
                        message: '必填',
                      },
                    ]" />
                  <van-popup v-model="showPicker1" position="bottom">
                    <van-datetime-picker type="date" @confirm="onConfirm1" @cancel="showPicker1 = false" :min-date="minDate" :max-date="maxDate" />
                  </van-popup>
                </van-cell-group>
                <!-- qq -->
                <!--                <van-cell-group class="biankuang">
                  <div class="label">
                    <span>*</span><span class="jianju">QQ</span>
                  </div>

                  <van-field v-model="formList.qq"
                             placeholder="请输入您的QQ号"
                             type="text"
                             maxlength="20"
                             :rules="[
                      {
                        required: true,
                        message: '必填',
                      },
                    ]" />
                </van-cell-group>-->
                <!-- 固定电话 -->
                <van-cell-group class="form_filed">
                  <div class="label">
                    <span style="margin-left:2.2vw"> </span><span class="jianju">固定电话</span>
                  </div>
                  <van-field v-model="formList.telephone" placeholder="请输入您的电话" class="input_box" type="text" maxlength="20" />
                </van-cell-group>
                <!-- 工作单位 -->
                <van-cell-group class="form_filed">
                  <div class="label">
                    <span class="xinhao">*</span><span class="jianju">工作单位</span>
                  </div>

                  <van-field v-model="formList.workplace" placeholder="请输入您的具体工作单位" type="text" class="input_box" maxlength="20" :rules="[
                      {
                        required: true,
                        message: '必填',
                      },
                    ]" />
                </van-cell-group>
                <!-- 单位性质 -->
                <van-cell-group class="form_filed">
                  <div class="label">
                    <span class="xinhao">*</span><span class="jianju">单位性质</span>
                  </div>

                  <van-field readonly clickable name="picker" class="input_box" :value="formList.unitKind" placeholder="请选择" @click="showPicker4 = true" :rules="[
                      {
                        required: true,
                        message: '必填',
                      },
                    ]" />
                  <van-popup v-model="showPicker4" position="bottom">
                    <van-picker show-toolbar :columns="unitKindList" @confirm="onConfirms3" @cancel="showPicker4 = false" value-key="name" />
                  </van-popup>
                </van-cell-group>
                <!-- 职业 -->
                <van-cell-group class="form_filed">
                  <div class="label">
                    <span class="xinhao">*</span><span class="jianju">职业</span>
                  </div>

                  <van-field v-model="formList.career" placeholder="请输入您的职业" type="text" class="input_box" maxlength="20" :rules="[
                      {
                        required: true,
                        message: '必填',
                      },
                    ]" />
                </van-cell-group>
                <!-- 现任职务 -->
                <van-cell-group class="form_filed" v-if="isVolunteerCertification != 2">
                  <div class="label">
                    <span class="xinhao">*</span><span class="jianju">现任职务</span>
                  </div>

                  <van-field v-model="formList.currentPosition" placeholder="请输入您的现任职务" type="text" class="input_box" maxlength="20" :rules="[
                      {
                        required: true,
                        message: '必填',
                      },
                    ]" />
                </van-cell-group>
                <div v-if="$route.query.isVolunteerCertification == 2">
                  <!-- 所属群团 -->
                  <!-- <van-cell-group class="form_filed">
                    <div class="label">
                      <span class="xinhao">*</span><span class="jianju">所属群团</span>
                    </div>

                    <van-field v-model="formList.belongGroup" placeholder="请输入您的所属群团" type="text" class="input_box" maxlength="20" :rules="[
                        {
                          required: true,
                          message: '必填',
                        },
                      ]" />
                  </van-cell-group> -->
                  <!-- 所属组织 -->
                  <van-cell-group class="form_filed">
                    <div class="label">
                      <span class="xinhao">*</span><span class="jianju">所属组织</span>
                    </div>

                    <van-field readonly clickable name="picker" class="input_box" :value="formList.orgKind" placeholder="请选择" @click="showPicker5 = true" :rules="[
                        {
                          required: true,
                          message: '必填',
                        },
                      ]" />
                    <van-popup v-model="showPicker5" position="bottom">
                      <van-picker show-toolbar :columns="orgKindList" @confirm="onConfirms4" @cancel="showPicker5 = false" value-key="name" />
                    </van-popup>
                  </van-cell-group>
                  <van-cell-group class="form_filed" v-if="formList.orgKind == '其他'">
                    <div class="label">
                      <span class="xinhao">*</span><span class="jianju"></span>
                    </div>

                    <van-field  v-model="formList.otherContent" placeholder="请输入所属组织" type="text" class="input_box" maxlength="20" :rules="[
                        {
                          required: true,
                          message: '必填',
                        },
                      ]" />
                  </van-cell-group>
                </div>

                <!-- <van-cell-group class="form_filed" v-if="$route.query.isVolunteerCertification == 1">
                  <div class="label"> <span class="xinhao">*</span><span class="jianju">证明材料</span></div>

                  <div class="van-cell van-field van-field--error">
                    <div style="padding: 1vw">
                      <p style="word-wrap: break-word; word-break: break-all">
                        请上传相关证明材料。支持JPEG、JPG、PNG、PDF格式
                      </p>
                      <div>
                        <div class="material-list">
                          <div class="material-item" v-for="(item, index) in formList.attachment" :key="index">
                            <div class="material-item-right">
                              <div class="material-item-right-flex">
                                <div class="material-item-name">
                                  <img src="../../assets/img/24gf-fileEmpty@3x.png" alt="" style="width: 5vw; vertical-align: middle" />
                                  {{ `${item.name}.${item.suffix}` }}
                                </div>
                                <div class="material-item-buttons">
                                  <i class="el-icon-refresh-left" v-if="item.type === 0" style="margin-right: 0.5rem" @click="uploadChange(item.oldFile, index)"></i>
                                  <span @click="deleteMaterial(index)">删除</span>
                                </div>
                              </div>
                              <van-progress :percentage="item.process" v-if="item.type === 2" />
                            </div>
                          </div>
                        </div>
                        <div @click="uploadClick" class="material-button" :style="formList.attachment.length >= 10 && 'display:none'">
                          <span>附件上传</span>
                          <input type="file" id="upload4" style="display: none" @change="uploadChange" />
                        </div>
                        <div v-if="mustUpdate" class="must-update">请上传附件</div>
                      </div>
                    </div>
                  </div>
                </van-cell-group> -->
                <!--  -->
                <!-- 认证协议 -->

                <van-field name="checkbox" class="xieyi">
                  <template #input>
                    <van-checkbox icon-size="4vw" v-model="formList.checkbox" shape="square" @change="checkboxs(formList.checkbox)" />
                    <span style="font-size:4vw;font-weight:700">请仔细阅读，同意并勾选<span style="color: #002FA7" @click="toxieyi">《认证协议》</span></span>
                    <div class="van-field__error-message" v-if="istrue">
                      请选择
                    </div>
                  </template>
                </van-field>
              </div>
            </div>
            <!-- 提交 -->
            <div style="margin: 16px" class="anniuyangshi">
              <van-button round block type="info" native-type="submit">提交</van-button>
            </div>
            <div style="margin: 16px" class="anniuyangshi">
              <van-button round block native-type="button" @click="tofanhui" style="color:#002FA7">取消</van-button>
            </div>
          </van-form>
        </div>
      </div>
      <div v-else>
        <!-- 审核中 -->
        <div v-if="form.status == 0">
          <div>
            <div class="renzheng-title">
              <div style="width: 20vw; text-align: center; margin: 3vw auto">
                <img src="../../assets/img/警告.png" alt="" />
              </div>
              <h4>审核中，预计1-5个工作日 <br />请等待</h4>
              <div>
                <van-button @click="fanhuipersonal"> 返回 </van-button>
              </div>
            </div>
          </div>
        </div>
        <!-- 审核失败 -->
        <div v-if="form.status == 2">
          <div>
            <div class="renzheng-title">
              <div style="width: 20vw; text-align: center; margin: 3vw auto">
                <img src="../../assets/img/失败报错-@3x.png" alt="" />
              </div>
              <h4>审核失败</h4>
              <div style="width: 76vw; margin: auto; font-size: 4vw;text-align:start">
                原因：<br />
                <div style="margin-top: 1vw ; ">{{ materialsResult}}</div>
              </div>
              <div>
                <van-button @click="fanhui"> 返回 </van-button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <!-- 协议书 -->
    <van-dialog v-model="show" style="height:90%;margin-top:5vw; overflow: auto;" :title="`互联网违法和不良信息网络${isVolunteerCertification == 1 ? '义务监督员':'举报志愿者'}协议书`">

      <div class="error-tip-title" v-html="isVolunteerCertification == 1?supervisorText:volunteerText">
        
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="button button-cancel" style="margin-right: 1rem;">确定</div>
      </div>
    </van-dialog>
    <!-- 邀请码弹框 -->
    <van-dialog v-model="showInvitation" title="邀请码" show-cancel-button clickable @confirm="queren()">
      <van-field v-model="Invitation" placeholder="邀请码" />
    </van-dialog>

  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { areaLists } from '@/utils/areaLists.js'
import moment from 'moment'
import ObsClient from 'esdk-obs-browserjs/src/obs'
import { encrypt } from '@/utils/security'
import { hwTemUrlUpload, isImageFile } from "@/utils/upload";

export default {
  name: '',
  props: {},
  data () {
    return {
      Invitation: '',
      showInvitation: false,
      Province1Value: '',
      City1Value: '',
      allowFileTypeList: ['jpeg', 'jpg', 'png', 'pdf'],
      params: {
        StartUpload: function () { },
        UploadProgress: function (percent, index, that) {
          that.formList.attachment[index].process = percent
        },
        FileUploaded: (url, index, file) => {
          this.formList.attachment[index].url = url
          this.formList.attachment[index].file = file
          this.formList.attachment[index].type = 1
        },
        CancelUpload: function () { }
      },
      show: false,
      native_place_province: false,
      native_place_city: false,
      isVolunteerCertification: '',
      materialsResult: '',
      time: 3 * 1000,
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(2100, 11, 30),
      currentDate: new Date(2021, 0, 17),
      value1: 0,
      value2: 'a',
      native_place: '',
      value3: 0,
      nationList: [],
      nationLists: [],
      columns: [
        '本科',
        '专科',
        '研究生',
        '博士生',
        '高中',
        '初中',
        '小学',
        '其他'
      ],
      columns1: ['群众', '共产党员', '共青团员', '民主党派'],
      politicsStatusList: [
        {
          name: '群众',
          value: 0
        },
        {
          name: '共产党员',
          value: 1
        },
        {
          name: '共青团员',
          value: 2
        },
        {
          name: '民主党派',
          value: 3
        }
      ],
      educationList: [
        { education: '本科', status: '1' },
        { education: '专科', status: '2' },
        { education: '研究生', status: '3' },
        { education: '博士生', status: '4' },
        { education: '高中', status: '5' },
        { education: '初中', status: '6' },
        { education: '小学', status: '7' },
        { education: '其他', status: '8' }
      ],
      pikerShow: {
        province_code__province: false,
        province_code__city: false,
        native_place__province1: false,
        native_place__city1: false
      },
      showPicker: false,
      showPicker1: false,
      showPicker2: false,
      showPicker3: false,
      showPicker4: false,
      showPicker5: false,
      formList: {
        belongGroup: '', // 所属群团
        education: '', // 学历
        native_place: { province1: '', city1: '' }, // 籍贯
        nation: '', // 民族
        idCard: '', // 身份证号
        politicsStatus: '', // 政治面貌
        birthDate: '', // 出生日期
        // qq: '',
        telephone: '', // 固定电话
        workplace: '', // 工作单位
        career: '', // 职业
        currentPosition: '', // 现任职务
        attachment: [{name:'ywjdy-zm',process:100,file:{},type:1,suffix:'jpg',url:'https://scjb-cdn.scde.cn/cdn/web/img/ywjdy-zm.jpg'}], // 证明材料
        checkbox: false, // 认证协议
        unitKind:'',
        orgKind:'',
        otherContent:''
      },
      form: {
        nativeProvince: '',
        nativeCity: '',
        status: '',
        inviteCode: ''
      },
      value: '',
      areaLists,
      showArea: false,
      isShow: false,
      currentPage: 1,
      number_page: 4,
      perpage: 2,
      istrue: false,
      isReportingMaterials: false,
      jubaoxinxitou: [
        { title: '举报类型' },
        { title: '危害小类' },
        { title: '被举报平台' },
        { title: '举报时间' },
        { title: '举报内容' },
        { title: '举报进度' },
        { title: '查看' }
      ],

      lists: [],
      are: [],
      areaList: {
        province_list: [],
        city_list: []
      },
      mustUpdate: false,
      volunteerText:`
        甲方：四川省网络治理研究中心<br>
        乙方：志愿者本人<br>
        为规范互联网信息服务活动，促进互联网信息服务健康有序发展，保证监督工作有序进行，甲、乙双方本着自愿、平等、公平的原则，签订本协议，由双方共同遵守。<br>
        第一条 鉴于甲方在治理网络空间的工作中需要第三方对网络环境进行监督的需要，乙方愿意以志愿者的身份利用业余时间义务对互联网违法和不良信息进行监督，经乙方提出并经甲方同意，由乙方担任甲方志愿者，乙方确认双方并无劳动关系，故甲方无需向乙方支付任何报酬或承担任何用人单位的责任。<br>
        第二条 甲方权利与义务<br>
        1.负责志愿者的招募、管理、培训、考核、解除等管理工作；<br>
        2.负责指导乙方开展义务监督工作；<br>
        3.对乙方提供的个人信息和举报信息严格保密；<br>
        4.认真受理乙方提交的违法和不良信息；<br>
        5.与乙方保持密切联系和沟通，听取意见和建议；<br>
        6.组织乙方开展各类活动。<br>
        第三条 乙方权利与义务<br>
        1.自觉遵守国家法律法规，在甲方的指导下正确行使监督权利；<br>
        2.向甲方提交真实、有效的个人信息，无虚假、欺诈行为；<br>
        3.定期主动向举报平台举报网上各类违法和不良信息；<br>
        4.对甲方提出意见和建议；<br>
        5.经所在单位批准，可申请取消志愿者资格；<br>
        6.不得以志愿者身份或以甲方名义进行任何与监督活动无关的行为；<br>
        7.严格遵守保密制度，不随意泄露传播相关工作信息。<br>
        第四条 志愿者资格终止情况<br>
        1.乙方自愿提出终止；<br>
        2.乙方在监督过程中从事与国家法律法规相违背或有损于甲方声誉的行为；<br>
        3.乙方在聘期内无法履行工作职责,未通过甲方检查；<br>
        4.乙方提供虚假个人信息或举报信息；<br>
        5.乙方以志愿者的身份或以甲方的名义进行任何与监督活动无关的行为；<br>
        6.甲方因工作需要，决定终止志愿者的工作。<br>
        第五条 甲乙方因履行本协议发生争执，应协商解决。经协商不能解决的，应当向甲方所在地人民法院起诉。<br>
        第六条 本次活动和本协议书的最终解释权归甲方所有。<br>
        第七条 本协议书自签订之日起生效。<br>
      `,
      supervisorText:`
        甲方：四川省网络治理研究中心<br>
        乙方：网络义务监督员本人<br>
        为规范互联网信息服务活动，促进互联网信息服务健康有序发展，保证监督工作有序进行，甲、乙双方本着自愿、平等、公平的原则，签订本协议，由双方共同遵守。<br>
        第一条 鉴于甲方在治理网络空间的工作中需要第三方对网络环境进行监督的需要，乙方愿意以网络义务监督员的身份利用业余时间义务对互联网违法和不良信息进行监督，经乙方提出并经甲方同意，由乙方担任甲方网络义务监督员，乙方确认双方并无劳动关系，故甲方无需向乙方支付任何报酬或承担任何用人单位的责任。<br>
        第二条 甲方权利与义务<br>
        1.负责网络义务监督员的招募、管理、培训、考核、解除等管理工作；<br>
        2.负责指导乙方开展义务监督工作；<br>
        3.对乙方提供的个人信息和举报信息严格保密；<br>
        4.认真受理乙方提交的违法和不良信息；<br>
        5.与乙方保持密切联系和沟通，听取意见和建议；<br>
        6.组织乙方开展各类活动。<br>
        第三条 乙方权利与义务<br>
        1.自觉遵守国家法律法规，在甲方的指导下正确行使监督权利；<br>
        2.向甲方提交真实、有效的个人信息，无虚假、欺诈行为；<br>
        3.定期主动向举报平台举报网上各类违法和不良信息；<br>
        4.对甲方提出意见和建议；<br>
        5.经所在单位批准，可申请取消网络义务监督员资格；<br>
        6.不得以网络义务监督员身份或以甲方名义进行任何与监督活动无关的行为；<br>
        7.严格遵守保密制度，不随意泄露传播相关工作信息。<br>
        第四条 网络义务监督员资格终止情况<br>
        1.乙方自愿提出终止；<br>
        2.乙方在监督过程中从事与国家法律法规相违背或有损于甲方声誉的行为；<br>
        3.乙方在聘期内无法履行工作职责,未通过甲方检查；<br>
        4.乙方提供虚假个人信息或举报信息；<br>
        5.乙方以网络义务监督员的身份或以甲方的名义进行任何与监督活动无关的行为；<br>
        6.甲方因工作需要，决定终止网络义务监督员的工作。<br>
        第五条 甲乙方因履行本协议发生争执，应协商解决。经协商不能解决的，应当向甲方所在地人民法院起诉。<br>
        第六条 本次活动和本协议书的最终解释权归甲方所有。<br>
        第七条 本协议书自签订之日起生效。<br>
      `,
      unitKindList:[],
      orgKindList:[]
    }
  },
  created () {
    this.form.status = 1
    this.init()
  },
  methods: {
    ...mapMutations(['setShowLoading', 'setActiveName', 'setMaterialsStatus']),
    queren () {
      // 判断邀请码是否正确
      this.$Api.inviteCheck({
        inviteCode: encrypt(this.Invitation),
        inviteType: this.$route.query.isVolunteerCertification
      }, {
        callback: (res) => {
          if (res.status !== 0) {
            this.$dialog.confirm({
              title: '提示',
              message: res.message
            })
          }
        },
        noToast: true
      }).then(() => {
        // 到认证失败的认证表单
        this.form.status = 1
      }).catch()
    },
    init () {
      this.setShowLoading(false)
      // 用户是否登录
      const token =
        localStorage.getItem('userInfo') &&
        JSON.parse(localStorage.getItem('userInfo')) &&
        JSON.parse(localStorage.getItem('userInfo')).token
      if (token) {
        // 显示登陆头像
        this.setActiveName(true)
      } else {
        this.setActiveName(false)
      }
      // 民族信息
      this.$Api.dictionaryList({ type: '2' }).then((res) => {
        this.nationList = res.list.map((res) => res.key)
        this.nationLists = res.list
      })
      // areaList市区联动查询
      this.$Api.areaList({ type: '1', parentId: '1' }).then((res) => {
        this.areaList.province_list = res.list
      })
      this.getUnitKindList()
      this.getOrgKindList()
      // 判断举报状态 0-待审核 1-已通过 2-未通过
      this.$Api.getIdentify({}, { noToast: true }).then(res => {
        if (res) {
          if (res.kind == Number(this.$route.query.isVolunteerCertification)) {
            this.form = res
            // 籍贯
            this.formList.native_place.province1 = res.nativeProvince
            this.formList.native_place.city1 = res.nativeCity
            this.formList.belongGroup = res.belongGroup
            this.formList.education = this.educationList.filter(
              (r) => r.status == res.education
            )[0].education
            setTimeout(() => {
              this.formList.nation = this.nationLists.filter(r =>
                r.id == res.nation
              )[0].key
              this.formList.birthDate = moment(res.birthDate).format('YYYY-MM-DD')
              this.formList.attachment = JSON.parse(res.attachments)
            }, 100)
            this.formList.politicsStatus = this.politicsStatusList.filter(
              (r) => {
                return r.value == res.politicsStatus
              }
            )[0].name
            this.formList.currentPosition = res.currentPosition
            this.formList.nation = res.nation
            this.formList.idCard = res.idCard

            this.formList.telephone = res.telephone
            this.formList.workplace = res.workplace
            this.formList.career = res.career
            /// / 籍贯
            this.form.nativeCity = res.nativeCity
            this.form.nativeProvince = res.nativeProvince
            this.form.inviteCode = res.inviteCode
            // 不通过原因
            this.materialsResult = res.auditResult
            this.formList.unitKind = res.unitName
            this.formList.orgKind = res.orgName
          } else {
            this.form.status = 1
            this.form.inviteCode = res.inviteCode
          }
        } else {
          this.form.status = 1
        }
      }).then((res) => {

      }).catch(() => {
        this.form.status = 1
      })
    },
    getUnitKindList(){
        this.$Api.getUnitKindList().then((res) => {
          this.unitKindList = res
        })
    },
    getOrgKindList(){
        this.$Api.getOrgKindList().then((res) => {
          this.orgKindList = res
        })
    },
    provinceChange () {
      this.areaList.city_list = []
      this.$Api
        .areaList({ type: '2', parentId: this.formList.native_place.province1 })
        .then((res) => {
          this.areaList.city_list = res.list
        })
    },
    // 籍贯
    onConfirm (values) {
      this.formList.native_place.province1 = values[0].name
      this.formList.native_place.city1 = values[1].name
      this.native_place = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join('---')
      this.showArea = false
    },
    onConfirms (value) {
      this.formList.education = value
      this.showPicker = false
    },
    onConfirms1 (value) {
      this.formList.nation = value
      this.showPicker2 = false
    },
    onConfirms2 (value) {
      this.formList.politicsStatus = value
      this.showPicker3 = false
    },
    onConfirms3 (value) {
      this.formList.unitKind = value.name
      this.showPicker4 = false
    },
    onConfirms4 (value) {
      this.formList.orgKind = value.name
      this.showPicker5 = false
    },
    onConfirm1 (value) {
      this.formList.birthDate = moment(value).format('YYYY-MM-DD')
      this.showPicker1 = false
    },
    onSubmit () {
      // if (this.$route.query.isVolunteerCertification == 1 && this.formList.attachment.length == 0) {
      //   return (this.mustUpdate = true)
      // }
      if (this.formList.checkbox == false) {
        return this.$toast('请仔细阅读，同意并勾选《认证协议》')
      }
      // 学历
      const arrEducation = this.educationList.filter(res => res.education == this.formList.education)
      const education = arrEducation[0].status
      // 民族
      const arrNation = this.nationLists.filter(res => res.key == this.formList.nation)
      const nation = arrNation[0].id
      // 政治面貌
      const arrPolitics = this.politicsStatusList.filter(res => res.name == this.formList.politicsStatus)
      const politicsStatus = arrPolitics[0].value
      // 类型
      const kind = this.$route.query.isVolunteerCertification
      // 籍贯省
      const nativeProvince = this.formList.native_place.province1
      // 籍贯市
      const nativeCity = this.formList.native_place.city1
      let unitKindItem = this.unitKindList.find(item => item.name == this.formList.unitKind)
      const unitKind = unitKindItem ? unitKindItem.type :''
      let orgKindItem = this.orgKindList.find(item => item.name == this.formList.orgKind)
      const orgKind = orgKindItem ? orgKindItem.type :''
      const otherContent = this.formList.otherContent
      // 提交确认
      this.$dialog
        .confirm({
          title: '确认',
          message:
            '提交后进行身份认证审核，大约需要1-5个工作日，确认是否提交？'
        })
        .then(() => {
          // on close
          // 提交接口
          this.$Api
            .userIdentify({
              kind, // 类型 0-网民 1-义务监督员 2-志愿者----
              education, // 学历 1-本科 2-专科 3-研究生 4-博士 5-高中 6-初衷 7-小学 8-其他
              nativeProvince, // 籍贯省份
              nativeCity, // 籍贯城市
              nation, // 民族
              idCard: this.formList.idCard, // 身份证号
              politicsStatus, // 政治面貌 0-群众 1-共产党员 2-共青团员 3-民主党派
              birthDate: this.formList.birthDate, // 出生日期
              telephone: this.formList.telephone, // 固定电话
              // qq: this.formList.qq, // qq号
              workplace: this.formList.workplace, // 工作单位
              career: this.formList.career, // 职业
              currentPosition: this.formList.currentPosition, // 现任职务
              belongGroup: this.formList.belongGroup, // 所属群团
              inviteCode: this.form.inviteCode || this.$route.query.inviteCode, // 邀请码（加密后）暂无，需求文档无此字段
              attachments: JSON.stringify(this.formList.attachment), // 附件json，格式[{"url":"","name":""}]
              unitKind,
              orgKind,
              otherContent
            })
            .then((res) => {
              // this.materialsStatusShow = false
              // this.setMaterialsStatus(res.materialsStatus)
              // if (this.materialsStatus == 0) {
              //   this.materialsStatus0 = true // 待审核
              // }
              // if (this.materialsStatus == 1) {
              //   this.materialsStatus1 = true // 已通过
              // }
              // if (this.materialsStatus == 2) {
              //   this.materialsStatus2 = true // 未通过
              //   this.materialsResult = res.materialsResult // 未通过原因
              // }
              window.location.reload()
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch(() => {
          //
        })
    },
    chankanhuifu (id) {
      this.isShow = true
    },
    location () {
      this.number_page = this.jubaoxinxishen.length / this.perpage
    },
    pagechange (page) {
      this.jubaoxinxishenlist = this.jubaoxinxishen.filter(
        (item, index) => index == (page - 1) / 1
      )
    },
    onOversize (file) {
      this.$toast('文件大小不能超过 200M')
    },
    toxieyi () {
      this.show = true
    },
    tofanhui () {
      this.$router.go(-1) // 0就是刷新页面
    },
    fanhui () {
      // 加验证码验证，验证成功到认证页面，失败不予跳转
      this.showInvitation = true
      // this.form.status = 1
    },
    fanhuipersonal () {
      this.$router.push({ path: '/personal' })
    },
    checkboxs (state) {
      this.istrue = !state
    },
    ReportingMaterialsChange () {
      this.isReportingMaterials = !(
        this.formList.attachment.length == 0
      )
    },
    uploadClick () {
      if (this.formList.attachment.length >= 10) {
        this.toast('当前列表文件数量已超限，无法继续上传！')
      } else {
        document.getElementById('upload4').click()
      }
    },
    async uploadChange (e, position) {
      this.$toast.loading({
        duration: 1000, // 持续展示 toast
        forbidClick: true
      })
      let file
      if (e.target) {
        file = e.target.files[0]
      } else {
        file = e
      }
      const fileName = file.name
        .slice(0, file.name.lastIndexOf('.'))
        .slice(0, 20)
      const suffix = file.name.slice(file.name.lastIndexOf('.') + 1)
      const isAllowFile = this.allowFileTypeList.indexOf(file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase()) > -1
      // eslint-disable-next-line no-constant-condition
      if (isAllowFile) {
        if (file.size <= 1024 * 1024 * 200) {
          try {
            const that = this
            let index
            if(position != undefined){
                index = position
                this.form.attachment[index] = {name:fileName,process:0,file:'',type:2,suffix}
            }else{
                this.form.attachment.push({name:fileName,process:0,file:'',type:2,suffix}) //type 上传状态类型 0->失败 1->成功 2->上传中
                index = this.form.attachment.length - 1
            }
            const getToken = isImageFile(file.name) ? this.$Api.getImageToken : this.$Api.getLeadToken
            const res = await getToken({ fileName: file.name })
            if(res.keyTokenParis[0].token) return hwTemUrlUpload(file, res,(percent, onCancel) => {
                this.form.attachment[index].process = parseInt(percent)
                this.form.attachment[index].onCancel = onCancel
            }, ({src, fileName}) => {
                if (src) {
                    this.form.attachment[index].url = src
                    this.form.attachment[index].file = fileName
                    this.form.attachment[index].type = 1
                } else {
                    this.form.attachment[index].type = 0
                }
            })

            // 上传改版  以下代码为旧版
            this.token = res

            // 上传云

            const uploader = new ObsClient({
              access_key_id: this.token.accessKey,
              secret_access_key: this.token.secretKey,
              server: this.token.endpoint,
              security_token: this.token.keyTokenParis[0].token,
              timeout: 24 * 60 * 60
            })

            // let index
            if (position != undefined) {
              index = position
              this.formList.attachment[index] = {
                name: fileName,
                process: 0,
                file: '',
                type: 2,
                suffix
              }
            } else {
              this.formList.attachment.push({
                name: fileName,
                process: 0,
                file: '',
                type: 2,
                suffix
              }) // type 上传状态类型 0->失败 1->成功 2->上传中
              index = this.formList.attachment.length - 1
            }
            const options = {
              Bucket: this.token.bucket,
              Key: this.token.keyTokenParis[0].key,
              SourceFile: file,
              ProgressCallback: function (
                transferredAmount,
                totalAmount,
                totalSeconds
              ) {
                that.params.UploadProgress(
                  parseInt((transferredAmount * 100) / totalAmount),
                  index,
                  that
                )
              }
            }

            uploader.putObject(options, function (err, res) {
              that.FileUploaded(err, uploader, index, file)
            })
            //
          } catch (error) {
            this.$dialog.alert({
              title: '提示',
              message: '有失败的文件!<br/>请检查！',
              theme: 'round-button',
              confirmButtonText: '知道了'
            })
          }
        } else {
          // this.formList.attachment.push({
          //   name: fileName,
          //   file: '',
          //   type: 0,
          //   oldFile: file,
          //   suffix
          // })
          this.$dialog.alert({
            title: '提示',
            message: '上传失败！文件总大小已超过200M！',
            theme: 'round-button',
            confirmButtonText: '知道了'
          })
        }
        this.mustUpdate = false
      } else {
        this.$dialog.alert({
          title: '提示',
          message: '上传失败！请检查材料格式！',
          theme: 'round-button',
          confirmButtonText: '知道了'
        })
      }
    },
    FileUploaded (err, uploader, index, flle) {
      var key = this.token.keyTokenParis[0].key
      var sign = this.token.keyTokenParis[0].sign
      if (err) {
        console.log(err)
        return
      }
      var url = this.token.host + '/' + key
      if (sign) {
        url = url + '?' + sign
      }
      this.params.FileUploaded(url, index, flle)
      uploader = null
    },
    deleteMaterial (index) {
      if (this.form.attachment[index].type === 2) {
        this.form.attachment[index].onCancel()
      }
      this.formList.attachment.splice(index, 1)
      if (this.formList.attachment.length < 10) {
      }
    },
    getAreaList (type, parentId) {
      // 0-国家、1-省/直辖市/自治区、2-市州、3-区县
      const params = {
        type,
        parentId
      }
      this.$Api.areaList(params).then((res) => {
        if (type == 1) {
          this.provinceList = res.data.data.list
        } else if (type == 2) {
          this.cityList = res.data.data.list
        }
      })
    },
    onConfirmCity (value, filed, clearFiled, type) {
      this.pikerShow[filed] = false
      this.formList[filed.split('__')[0]][filed.split('__')[1]] = value.id
      if (clearFiled) {
        this.formList[clearFiled.split('__')[0]][clearFiled.split('__')[1]] =
          ''
      }
      if (type === '1' || type === '3') {
        type === '1' && (this.city_list = [])
        type === '3' && (this.areaList.city_list = [])
        this.$Api.areaList({ type: '2', parentId: value.id }).then((res) => {
          type === '1' && (this.city_list = res.list)
          type === '3' && (this.areaList.city_list = res.list)
        })
      }
    }
  },
  computed: {
    ...mapState(['ActiveName', 'materialsStatus']),
    province_val () {
      const val = this.formList.native_place.province1 ? this.areaList.province_list.find((v) => v.id / 1 === this.formList.native_place.province1) : this.form.nativeProvince ? this.areaList.province_list.find((v) => v.id / 1 === this.form.nativeProvince) : ''
      const vals = val && val.name
      return vals
    },
    city1_val () {
      const val = this.formList.native_place.city1 ? this.areaList.city_list.find((v) => v.id / 1 === this.formList.native_place.city1) : this.form.nativeCity ? this.areaList.city_list.find((v) => v.id / 1 === this.form.nativeCity) : ''

      const vals = val && val.name

      return vals

      // return vals
      // formList.native_place.city1 ? areaList.city_list.find((v) => v.id / 1 === formList.native_place.city1).name : ''
      // if (this.formList.native_place.city1) {

      //   const val = this.areaList.city_list.find((v) => v.id / 1 === this.formList.native_place.city1)
      //   return val && val.name
      // } else if (this.form.nativeCity) {

      //   const val = this.areaList.city_list.find((v) => v.id / 1 === this.form.nativeCity)
      //   return val && val.name
      // }
      // return true
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler () {
        this.isVolunteerCertification = this.$route.query.isVolunteerCertification
      }
    },
    province1: {
      immediate: true,
      handler () {
        setTimeout(() => {
          this.formList.native_place.city1 = ''
          this.$Api.areaList({ type: '2', parentId: this.form.nativeProvince }).then((res) => {
            const e = res.list.filter(r => r.id == Number(this.form.nativeCity))
            this.City1Value = e && e[0] && e[0].name
          })
        }, 1000)
      }
    },
    // attachment: {
    //   immediate: true,
    //   handler () {
    //     if (this.formList.attachment.length > 0) {
    //       this.mustUpdate = false
    //     }
    //   }
    // },
    form: {
      immediate: true,
      handler () {
        setTimeout(() => {
          this.$Api.areaList({ type: '2', parentId: this.form.nativeProvince }).then((res) => {
            const e = res.list.filter(r => r.id == Number(this.form.nativeCity))
            this.areaList.city_list = e
          })
          this.formList.native_place.city1 = this.form.nativeCity
        }, 1000)
      }
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
.Authentication {
  height: 100%;
}
.Authentication-center {
  box-sizing: border-box;
  padding: 3vw;
  font-size: 4vw;
  min-height: 68vh;
}
.Authentication-content {
  .van-cell__title,
  .van-cell__value {
    flex: none !important;
  }
}
.biaoge {
  width: 38vw;
  height: 8vw;
  border: 2px solid rgba(0, 0, 0, 0.15);
}
.biaoge1 {
  width: 100%;
  height: 8vw;
  border: 2px solid rgba(0, 0, 0, 0.15);
}
.van-field__error-message {
  font-size: 3vw;
}
.renzheng-title {
  height: 80vw;
  text-align: center;
  margin: 7vw 0;
  font-size: 4vw;
}
.Authentication-title {
  position: relative;
  text-align: center;
  margin: 5vw auto;
  font-size: 4.5vw;
  font-weight: 700;
  i {
    position: absolute;
    top: 120%;
    left: 50%;
    width: 5vw;
    transform: translate(-50%, -50%);
    border-bottom: 1vw solid #0852c8;
  }
}
.error-tip-title {
  font-size: 3.8vw;
  font-weight: 700;
  margin-top: 3vw;
}
.material-button {
  background-color: #002fa7;
  color: #fff;
  font-size: 4vw;
  font-weight: 700;
  width: 80%;
  height: 10vw;
  line-height: 10vw;
  text-align: center;
  margin-left: 10vw;
  margin-top: 3vw;
}
.material-item-right-flex {
  display: flex;
  justify-content: space-between;
  background-color: #f6f8fa;
  margin: 2vw 0;
}
.material-item-buttons {
  display: flex;
  align-items: center;
}

.upload_err {
  text-align: center;
  color: red;
}
.must-update {
  text-align: center;
  color: red;
}
</style>
